import script from "./PhotoGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts&setup=true"

import "./PhotoGallery.vue?vue&type=style&index=0&id=06fbf344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fbf344"]])

export default __exports__